import { styled } from 'shared/ui';

export const ChatWrapper = styled('div', {
  position: 'fixed',
  width: '672px',
  zIndex: '100',
});
